<template>
  <UiNavigationCard
    class="product-type-card"
    :class="{
      'product-type-card--bordered': bordered,
      'product-type-card--active': isActive,
    }"
  >
    <UiNavigationCardImage
      :src="productType.image?.src"
      :alt="productType.image?.alt"
      :width="productType.image?.width"
      :height="productType.image?.height"
    />
    <UiNavigationCardTitle> {{ productType.title }} </UiNavigationCardTitle>
  </UiNavigationCard>
</template>

<script setup lang="ts">
import {
  UiNavigationCard,
  UiNavigationCardImage,
  UiNavigationCardTitle,
} from '~/ui';
export interface Props {
  productType: {
    image: {
      src: string;
      alt?: string;
      width?: number;
      height?: number;
    };
    title: string;
  };
  isActive?: boolean;
  bordered?: boolean;
}

defineProps<Props>();
</script>

<style lang="scss">
.product-type-card {
  width: 100%;

  &--bordered {
    .ui-navigation-card-image {
      padding: 9px 12.5px;
      border: 1px solid;
      border-radius: 12px;
      border-color: rgb(var(--v-theme-border-primary));
      transition: all 0.25s;
      + * {
        margin-top: 8px;
      }
    }
    p {
      transition: all 0.25s;
    }

    &:hover {
      &:not(.product-type-card--active) {
        .ui-navigation-card-image {
          border-color: rgb(var(--v-theme-border-link));
        }
        p {
          color: rgb(var(--v-theme-text-link));
        }
      }
    }
  }
  &--active {
    .ui-navigation-card-image {
      border-color: rgb(var(--v-theme-primary));
    }
    p {
      color: rgb(var(--v-theme-text-accent));
    }
  }
}
</style>
